export class AdminUserEntityModel {
    constructor(data) {
        this.entityId = data.entityId;
        this.userEntityId = data.userEntityId;
        this.entityName = data.entityName;
        this.email = data.email;
        this.fullName = data.fullName;
        this.hasUploaded = data.hasUploaded;
        this.lastUploadDate = data.lastUploadDate;
        this.userId = data.userId;
        this.canLogin = data.canLogin;
    }
}